import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import DocumentMeta from 'react-document-meta';
import i18n from 'kodyl-js/i18n/react';
import { setStatusCode } from '../redux/modules/app';

@i18n
class NotFound extends Component {
  static fetchData({ dispatch }) {
    return dispatch(setStatusCode(404));
  }

  render() {
    return (
      <DocumentMeta canonical={null} extend>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1>
                {this.i18n('Ups! Siden findes ikke')}
                <span>:(</span>
              </h1>
              <p>
                {this.i18n(
                  'Beklager, men den side, du forsøgte at se, eksisterer desværre ikke.'
                )}
              </p>
              <p>{this.i18n('Det skyldes umiddelbart en af følgende:')}</p>
              <ul>
                <li>{this.i18n('en fejl i adressen')}</li>
                <li>
                  {this.i18n('et gammelt link til en side som er fjernet')}
                </li>
              </ul>
            </Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default NotFound;
